import tradeapi from '@/api/trade'
// import { getStore } from '@/utils/common'

const trade = {
  state: {
    total: 0,
    rows: [],
    row: {},
    temp: {},
    spot: [],
    futures: [],
    counter: 0,
    dict: {},
    nav: null,
    isRefresh: false
  },
  mutations: {
    SET_TOTAL: (state, total) => {
      state.total = total
    },
    SET_ROWS: (state, rows) => {
      state.rows = rows
    },
    SET_ROW: (state, row) => {
      state.row = row
    },
    SET_TEMP: (state, temp) => {
      state.temp = temp
    },
    SET_SPOT: (state, sopt) => {
      state.sopt = sopt
    },
    SET_FUTURES: (state, futures) => {
      state.futures = futures
    },
    SET_COUNTER: (state, counter) => {
      state.counter = counter
    },
    SET_DICT: (state, dict) => {
      state.dict = dict
    },
    SET_NAV: (state, nav) => {
      state.nav = nav
    },
    SET_ISREFRESH: (state, isRefresh) => {
      state.isRefresh = isRefresh
    }
  },
  actions: {
    // 个人中心导航
    SetNav({ commit }, params) {
      commit('SET_NAV', params)
    },
    // 添加现货部位
    SetSpot({ commit }, params) {
      commit('SET_SPOT', params)
    },
    // 添加期货部位
    SetFutures({ commit }, params) {
      commit('SET_FUTURES', params)
    },
    // 设置临时变量
    SetTemp({ commit }, params) {
      commit('SET_TEMP', params)
    },
    // 新增报盘
    AddBuyerOffer({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.addBuyerOffer(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 报盘查询
    GetBuyerOffers({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getBuyerOffers(params).then((response) => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询大数据智推
    GetSmartPushInfo({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getSmartPushInfo(params).then((response) => {
          commit('SET_ROW', response.Data.Row)
          commit('SET_ROWS', response.Data.GRows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询必孚推送
    GetBtcPushInfo({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getBtcPushInfo(params).then((response) => {
          commit('SET_ROW', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询订单详情
    GetOfferDetail({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getOfferDetail(params).then((response) => {
          commit('SET_ROW', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 买方确认订单
    BuyerConfirmOrder({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.buyerConfirmOrder(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询买方确认状态
    GetBuyerOfferState({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getBuyerOfferState(params).then((response) => {
          commit('SET_ROW', response.Data.Dicts)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询卖方集结单
    GetSellerOffers({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getSellerOffers(params).then((response) => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 卖方确认订单
    SellerConfirmOrder({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.sellerConfirmOrder(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询集结单详情
    GetAssemblyOfferDetail({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getAssemblyOfferDetail(params).then((response) => {
          commit('SET_ROW', response.Data.Row)
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询卖方集结单（期货）
    GetSellerFuturesOffers({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getSellerFuturesOffers(params).then((response) => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 卖方出价
    SellerQuate({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.sellerQuate(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询卖方状态
    GetSellerState({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getSellerState(params).then((response) => {
          commit('SET_ROW', response.Data.Dicts)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 根据ID查询报盘
    GetBuyerOfferByID({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getBuyerOfferByID(params).then((response) => {
          commit('SET_ROW', response.Data.Dicts)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 买方确认
    BuyerConfirmFuturesOffer({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.buyerConfirmFuturesOffer(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 修改卖方状态
    UpdateSellerState({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.updateSellerState(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 是否已有卖家接受
    HasSellerAccepted({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.hasSellerAccepted(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 修改卖方新消息状态
    UpdateSellerFlag({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.updateSellerFlag(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询期货集结
    GetFuturesAssemblyOfferDetail({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getFuturesAssemblyOfferDetail(params).then((response) => {
          commit('SET_ROW', response.Data.Row)
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询公司信息
    GetCompanyInfoByUserName({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getCompanyInfoByUserName(params).then((response) => {
          commit('SET_ROW', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询智推试用次数
    GetSmartPushViewNumber({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getSmartPushViewNumber(params).then((response) => {
          commit('SET_ROW', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询期货订单详情
    GetFuturesOfferDetail({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getFuturesOfferDetail(params).then((response) => {
          commit('SET_ROW', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询集结买方信息
    GetFuturesAssemblyBuyerDetail({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getFuturesAssemblyBuyerDetail(params).then((response) => {
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询供应信息
    GetCompanySupplyInfo({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getCompanySupplyInfo(params).then((response) => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 修改供应信息
    UpdateCompanySupplyInfo({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.updateCompanySupplyInfo(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询与进口商实时匹配的报盘
    GetRealTimeOfferOfSupplier({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getRealTimeOfferOfSupplier(params).then((response) => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询供应信息筛选条件
    GetCompanySupplyInfoFilter({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getCompanySupplyInfoFilter(params).then((response) => {
          commit('SET_ROWS', response.Data.Res)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // ``````````````````````````````````````` 期货 ````````````````````````````````````
    // 查询进口商列表
    GetImportersList({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getImportersList(params).then((response) => {
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询进口商联系人
    GetImporterContact({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getImporterContact(params).then((response) => {
          commit('SET_ROW', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询交易参考信息
    GetTradingReference({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getTradingReference(params).then((response) => {
          commit('SET_ROW', response.Data.List)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询交易参考信息国别
    GetTradingReferenceOrigin({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getTradingReferenceOrigin(params).then((response) => {
          commit('SET_ROW', response.Data.Dicts)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询交易参考信息厂号
    GetTradingReferencePlantNo({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getTradingReferencePlantNo(params).then((response) => {
          commit('SET_ROW', response.Data.Dicts)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询交易参考信息详情
    GetTradingReferenceDetail({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getTradingReferenceDetail(params).then((response) => {
          commit('SET_ROW', response.Data.Dicts)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询出口商信息
    GetExporterInfo({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getExporterInfo(params).then((response) => {
          commit('SET_ROW', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 修改出口商信息
    UpdateExporterInfo({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.updateExporterInfo(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // ----------------------------------------------------------- 新Api ----------------------------------
    GetApprovedPlantOrigins({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getApprovedPlantOrigins(params).then((response) => {
          commit('SET_ROWS', response.Data.Dict.Res)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetApprovedPlantNo({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getApprovedPlantNo(params).then((response) => {
          commit('SET_ROWS', response.Data.Dict.Res)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetApprovedPlantInfo({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getApprovedPlantInfo(params).then((response) => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    ApprovedPlantCollection({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.approvedPlantCollection(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    ApprovedPlantSearchCount({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.approvedPlantSearchCount(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetApprovedPlantCollection({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getApprovedPlantCollection(params).then((response) => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetPlantSearchInfo({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getPlantSearchInfo(params).then((response) => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_COUNTER', response.Data.Counter)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    UploadPlantAppendix({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.uploadPlantAppendix(params).then((response) => {
          commit('SET_ROW', response.Data.Dict)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    SendFuturesEmail({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.sendFuturesEmail(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetImporterReceive({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getImporterReceive(params).then((response) => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_ROWS', response.Data.Dict.Res)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetImporterReceiveMails({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getImporterReceiveMails(params).then((response) => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetExporterReceiveMails({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getExporterReceiveMails(params).then((response) => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetImporterReceiveMailDetail({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getImporterReceiveMailDetail(params).then((response) => {
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetExporterReceiveMailDetail({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getExporterReceiveMailDetail(params).then((response) => {
          commit('SET_ROW', response.Data.Dict)
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetImporterSender({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getImporterSender(params).then((response) => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_ROWS', response.Data.Dict.Res)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetImporterSenderMails({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getImporterSenderMails(params).then((response) => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetImporterSenderMailDetail({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getImporterSenderMailDetail(params).then((response) => {
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetExporterSender({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getExporterSender(params).then((response) => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_ROWS', response.Data.Dict.Res)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetExporterSenderMails({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getExporterSenderMails(params).then((response) => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetExporterSenderMailDetail({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getExporterSenderMailDetail(params).then((response) => {
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetExporterReceive({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getExporterReceive(params).then((response) => {
          commit('SET_ROWS', response.Data.Dict.Res)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetTradingRefComments({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getTradingRefComments(params).then((response) => {
          commit('SET_ROWS', response.Data.Dict.Res)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetTradingRefCommentChildren({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getTradingRefCommentChildren(params).then((response) => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    PostTradingRefComments({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.postTradingRefComments(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    PostTradingRefCommentLisk({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.postTradingRefCommentLisk(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetApprovedPlantByID({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getApprovedPlantByID(params).then((response) => {
          commit('SET_ROW', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetImportersByID({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getImportersByID(params).then((response) => {
          commit('SET_ROW', response.Data.Row)
          commit('SET_DICT', response.Data.Dict)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    ImporterHasUnreadMail({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.importerHasUnreadMail(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    DeleteEmailAppendix({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.deleteEmailAppendix(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetApprovePlantStateOrigin({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getApprovePlantStateOrigin(params).then((response) => {
          commit('SET_ROW', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetApprovePlantStatePlantNO({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getApprovePlantStatePlantNO(params).then((response) => {
          commit('SET_ROW', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetApprovePlantState({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getApprovePlantState(params).then((response) => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetApprovePlantChildState({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getApprovePlantChildState(params).then((response) => {
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetFactoryPermission({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getFactoryPermission(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetSmartPushChildInfo({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getSmartPushChildInfo(params).then((response) => {
          commit('SET_ROWS', response.Data.GRows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询大数据智推
    GetSmartPushInfolimit({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getSmartPushInfolimit(params).then((response) => {
          commit('SET_ROW', response.Data.Row)
          commit('SET_ROWS', response.Data.GRows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetSmartPushChildInfoLimit({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getSmartPushChildInfoLimit(params).then((response) => {
          commit('SET_ROWS', response.Data.GRows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    AddRealTimeSource({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.addRealTimeSource(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    UpdateRealTimeSource({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.updateRealTimeSource(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    DeleteSmartPushDot({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.deleteSmartPushDot(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetUserNewSmartPush({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getUserNewSmartPush(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetUserNewRealTimeOffer({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getUserNewRealTimeOffer(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    ClearRealTimeDemandDot({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.clearRealTimeDemandDot(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取必孚金融实时汇率
    GetFinancialRate({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getFinancialRate(params).then((response) => {
          resolve(response.Data.CurrentRate)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 提交必孚金融需求
    CommitFinancialRequest({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.commitFinancialRequest(params).then((response) => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取代理公司列表
    GetBeefAgent({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getBeefAgent(params).then((response) => {
          resolve(response.Data.Agents)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 上传必孚肉集图片
    UploadCirclePicture({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.uploadCirclePicture(params).then((response) => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 发布必孚圈
    PublishCircle({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.publishCircle(params).then((response) => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询期货代理金融
    GetFinancialAppeal({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getFinancialAppeal(params).then((response) => {
          resolve(response.Data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询期货代理金融
    GetAgentUserCircle({ commit }, params) {
      return new Promise((resolve, reject) => {
        tradeapi.getAgentUserCircle(params).then((response) => {
          resolve(response.Data)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default trade



// WEBPACK FOOTER //
// ./src/store/modules/trade.js